import {Component, OnInit, ViewChild} from '@angular/core';
import 'rxjs-compat/add/observable/defer';
import {ProfileService} from '~/app/core/common/services/profile.service';
import {ProfileCategoriesService} from '~/app/core/common/services/profile-categories.service';
import {ComponentCanDeactivate} from '~/app/shared/navigation/component-can-deactivate';
import {MatTabGroup} from '@angular/material/tabs';
import {StoreListService} from '~/app/core/common/services/store-list.service';
import {LoadingIndicatorHelper} from '~/app/shared/helpers/loading-indicator-helper';
import { ApplicationSettingsHelper } from '~/app/shared/helpers/application-settings-helper';

@Component({
    selector: 'app-profile',
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.scss']
})
export class ProfileComponent extends ComponentCanDeactivate implements OnInit {

    @ViewChild('tabs', {static: false}) tabGroup: MatTabGroup;
    public hide: boolean;
    public powerUserName:string;
    public userSecurity=[];
    public customerId;
    constructor(public profileService: ProfileService,
                public profileCategoriesService: ProfileCategoriesService,
                private _storeListService: StoreListService,
                private _loadingIndicatorHelper: LoadingIndicatorHelper,
                private _applicationSettingsHelper: ApplicationSettingsHelper) {
        super();
    }

    async ngOnInit() {
        this._loadingIndicatorHelper.show('');
        this.getStoreLogins();

        this.hide = this._storeListService.allowCustomizedList();
        // TODO if Store selection changed, update categories when store changed
        if (this.profileCategoriesService.customerCategories === undefined) {
            await this.profileCategoriesService.getCustomerCategories();
        }
        this._loadingIndicatorHelper.hide();
    }

    canDeactivate(): boolean {
        return !this.profileService.itemsSaved;
    }

    /* Filtering poweruser userName from store login user List */
    getStoreLogins(){
        this.customerId=this._applicationSettingsHelper.getCustomerId();
         this.profileService.getStoreLogins(this.customerId).toPromise().then(r => {
           this.userSecurity=r;
           this._loadingIndicatorHelper.hide();
          let powerUsers= r.filter(i =>  i.security == 'POWERUSER').map(i => i.username)
          .filter(function(elem, index, self) {
            return index === self.indexOf(elem);
        }).join(",");
         this.powerUserName=powerUsers;
        });
      }

}
